export default __webpack_public_path__ + "icon-gen-ai-sparkle.dad3e021.svg";